import { useNavigate, useParams } from '@tanstack/react-router';
import { memo, useCallback } from 'react';

import GoBackIcon from '@/assets/flip-backward.svg?react';
import { Button, Icon, Text } from '@/components/core';
import { InboxProvider } from '@/store';

import { AgentRunsEmpty } from '../inbox/AgentRunsEmpty';
import { DetailsAgentRunsPanelWrapper } from './DetailsAgentRunsPanelWrapper';

const INoMoreTasksToValidate = () => {
  const { agentId } = useParams({ from: '/_auth/details/agents/$agentId/empty' });
  const navigate = useNavigate();

  const onBackToRuns = useCallback(() => {
    if (agentId) {
      navigate({
        to: '/agents/$agentId/inbox',
        params: { agentId },
      }).catch(console.error);
    }
  }, [navigate, agentId]);

  return (
    <InboxProvider agentId={agentId}>
      <div className="flex h-full w-full bg-gray-50">
        <div className="flex min-h-0 bg-white">
          <DetailsAgentRunsPanelWrapper agentId={agentId} />
        </div>

        <AgentRunsEmpty agentId={agentId} location="review-completed">
          <Button variant="secondary" onPress={onBackToRuns}>
            <Icon SVGComponent={GoBackIcon} className="size-4" />
            <Text>Back to runs</Text>
          </Button>
        </AgentRunsEmpty>
      </div>
    </InboxProvider>
  );
};

export const NoMoreTasksToValidate = memo(INoMoreTasksToValidate);
